import { render, staticRenderFns } from "./AirportDetails.vue?vue&type=template&id=35c4e6dd&"
import script from "./AirportDetails.vue?vue&type=script&lang=js&"
export * from "./AirportDetails.vue?vue&type=script&lang=js&"
import style0 from "./AirportDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports